import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getStudentProfile = async () => {
  const { data } = await axiosInstance.get("/student-dashboard/profile");
  return data;
};

export const getStudentNotices = async () => {
  const { data } = await axiosInstance.get("/student-dashboard/notices");
  return data;
};
